//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import { trace, context, TraceFlags, Span } from '@opentelemetry/api';

import { ClientBase } from './client-base';
import { inject } from 'aurelia-framework';
import { HttpClient, RequestInit } from 'aurelia-fetch-client';

export class InstrumentClientBase extends ClientBase {
  getBaseUrl(_defaultUrl: string, _baseUrl: string) {
    return this.apiService.getServiceUrl('instrumentlookup-api');
  }
}

@inject(String, HttpClient)
export class AvailableInstrumentClient extends InstrumentClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("AvailableInstrumentClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5310", baseUrl);
    }

    async searchFuzzy(companyIdentityId: number, request: QueryLookupInstrumentsRequest): Promise<QueryInstrumentsResponseItem[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/AvailableInstrument/SearchFuzzy", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/AvailableInstrument/SearchFuzzy";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSearchFuzzy(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSearchFuzzy(response: Response): Promise<QueryInstrumentsResponseItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QueryInstrumentsResponseItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryInstrumentsResponseItem[]>(null as any);
    }

    async searchByIsins(companyIdentityId: number, isins: string[]): Promise<QueryInstrumentsResponseItem[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/AvailableInstrument/SearchByIsins", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/AvailableInstrument/SearchByIsins";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(isins);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSearchByIsins(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSearchByIsins(response: Response): Promise<QueryInstrumentsResponseItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QueryInstrumentsResponseItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryInstrumentsResponseItem[]>(null as any);
    }

    async exchanges(companyIdentityId: number, lookupAvailableInstrumentIds: string[]): Promise<LookupExchangeResponseItem[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/AvailableInstrument/Exchanges", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/AvailableInstrument/Exchanges";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lookupAvailableInstrumentIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processExchanges(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processExchanges(response: Response): Promise<LookupExchangeResponseItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupExchangeResponseItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupExchangeResponseItem[]>(null as any);
    }
}

export class QueryInstrumentsResponseItem implements IQueryInstrumentsResponseItem {
    transactionAvailableInstrumentId?: string | undefined;
    transactionInstrumentId?: string | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    isin?: string | undefined;
    existingInstrument?: boolean | undefined;
    name?: string | undefined;
    reportName?: string | undefined;
    ticker?: string | undefined;
    currencyCode?: string | undefined;
    orgNr?: string | undefined;
    sortOrder?: number | undefined;
    feedDescription?: string | undefined;
    countryCode?: string | undefined;
    infrontPriceType?: string | undefined;
    possibleInstrumentTypesIds?: InstrumentType[] | undefined;
    companyIdentityId?: number | undefined;
    instrumentId?: number | undefined;
    typeShortName?: string | undefined;
    exchangeName?: string | undefined;
    mic?: string | undefined;
    categories?: SectorMessageModel[];
    fetchSectors?: boolean;
    lastUpdated?: string | undefined;
    instrumentTypeId?: InstrumentType | undefined;
    instrumentTaxable?: boolean | undefined;
    instrumentLongTerm?: boolean | undefined;
    instrumentLowerOfCostOrMarket?: boolean | undefined;
    instrumentState?: InstrumentState;

    constructor(data?: IQueryInstrumentsResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionAvailableInstrumentId = _data["TransactionAvailableInstrumentId"];
            this.transactionInstrumentId = _data["TransactionInstrumentId"];
            this.lookupAvailableInstrumentId = _data["LookupAvailableInstrumentId"];
            this.isin = _data["Isin"];
            this.existingInstrument = _data["ExistingInstrument"];
            this.name = _data["Name"];
            this.reportName = _data["ReportName"];
            this.ticker = _data["Ticker"];
            this.currencyCode = _data["CurrencyCode"];
            this.orgNr = _data["OrgNr"];
            this.sortOrder = _data["SortOrder"];
            this.feedDescription = _data["FeedDescription"];
            this.countryCode = _data["CountryCode"];
            this.infrontPriceType = _data["InfrontPriceType"];
            if (Array.isArray(_data["PossibleInstrumentTypesIds"])) {
                this.possibleInstrumentTypesIds = [] as any;
                for (let item of _data["PossibleInstrumentTypesIds"])
                    this.possibleInstrumentTypesIds!.push(item);
            }
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.instrumentId = _data["InstrumentId"];
            this.typeShortName = _data["TypeShortName"];
            this.exchangeName = _data["ExchangeName"];
            this.mic = _data["Mic"];
            if (Array.isArray(_data["Categories"])) {
                this.categories = [] as any;
                for (let item of _data["Categories"])
                    this.categories!.push(SectorMessageModel.fromJS(item));
            }
            this.fetchSectors = _data["FetchSectors"];
            this.lastUpdated = _data["LastUpdated"];
            this.instrumentTypeId = _data["InstrumentTypeId"];
            this.instrumentTaxable = _data["InstrumentTaxable"];
            this.instrumentLongTerm = _data["InstrumentLongTerm"];
            this.instrumentLowerOfCostOrMarket = _data["InstrumentLowerOfCostOrMarket"];
            this.instrumentState = _data["InstrumentState"];
        }
    }

    static fromJS(data: any): QueryInstrumentsResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new QueryInstrumentsResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TransactionAvailableInstrumentId"] = this.transactionAvailableInstrumentId;
        data["TransactionInstrumentId"] = this.transactionInstrumentId;
        data["LookupAvailableInstrumentId"] = this.lookupAvailableInstrumentId;
        data["Isin"] = this.isin;
        data["ExistingInstrument"] = this.existingInstrument;
        data["Name"] = this.name;
        data["ReportName"] = this.reportName;
        data["Ticker"] = this.ticker;
        data["CurrencyCode"] = this.currencyCode;
        data["OrgNr"] = this.orgNr;
        data["SortOrder"] = this.sortOrder;
        data["FeedDescription"] = this.feedDescription;
        data["CountryCode"] = this.countryCode;
        data["InfrontPriceType"] = this.infrontPriceType;
        if (Array.isArray(this.possibleInstrumentTypesIds)) {
            data["PossibleInstrumentTypesIds"] = [];
            for (let item of this.possibleInstrumentTypesIds)
                data["PossibleInstrumentTypesIds"].push(item);
        }
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["InstrumentId"] = this.instrumentId;
        data["TypeShortName"] = this.typeShortName;
        data["ExchangeName"] = this.exchangeName;
        data["Mic"] = this.mic;
        if (Array.isArray(this.categories)) {
            data["Categories"] = [];
            for (let item of this.categories)
                data["Categories"].push(item ? item.toJSON() : undefined as any);
        }
        data["FetchSectors"] = this.fetchSectors;
        data["LastUpdated"] = this.lastUpdated;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        data["InstrumentTaxable"] = this.instrumentTaxable;
        data["InstrumentLongTerm"] = this.instrumentLongTerm;
        data["InstrumentLowerOfCostOrMarket"] = this.instrumentLowerOfCostOrMarket;
        data["InstrumentState"] = this.instrumentState;
        return data;
    }
}

export interface IQueryInstrumentsResponseItem {
    transactionAvailableInstrumentId?: string | undefined;
    transactionInstrumentId?: string | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    isin?: string | undefined;
    existingInstrument?: boolean | undefined;
    name?: string | undefined;
    reportName?: string | undefined;
    ticker?: string | undefined;
    currencyCode?: string | undefined;
    orgNr?: string | undefined;
    sortOrder?: number | undefined;
    feedDescription?: string | undefined;
    countryCode?: string | undefined;
    infrontPriceType?: string | undefined;
    possibleInstrumentTypesIds?: InstrumentType[] | undefined;
    companyIdentityId?: number | undefined;
    instrumentId?: number | undefined;
    typeShortName?: string | undefined;
    exchangeName?: string | undefined;
    mic?: string | undefined;
    categories?: SectorMessageModel[];
    fetchSectors?: boolean;
    lastUpdated?: string | undefined;
    instrumentTypeId?: InstrumentType | undefined;
    instrumentTaxable?: boolean | undefined;
    instrumentLongTerm?: boolean | undefined;
    instrumentLowerOfCostOrMarket?: boolean | undefined;
    instrumentState?: InstrumentState;
}

export enum InstrumentType {
    StocksNoted = 1,
    EquityCertificate = 2,
    Bonds = 3,
    FixedIncomeFunds = 4,
    Derivatives = 5,
    Stocks = 7,
    Dividend = 8,
    Repayment = 9,
    EquityFunds = 10,
    Currency = 13,
    Bank = 14,
    ETF = 15,
    ETN = 16,
    StocksSubsidiaries = 50,
    StocksAssociatedCompanies = 51,
    Loans = 52,
    LoansSubsidiaries = 53,
    LoansAssociatedCompanies = 54,
    Property = 55,
    OtherAssets = 56,
    Partnership = 57,
    Cfd = 58,
    Etc = 59,
    ShortPosition = 60,
}

export class SectorMessageModel implements ISectorMessageModel {
    categoryId?: number | undefined;
    externalId?: string | undefined;
    name?: string | undefined;
    portion?: number;
    externalType?: string | undefined;
    categoryType?: number | undefined;

    constructor(data?: ISectorMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["CategoryId"];
            this.externalId = _data["ExternalId"];
            this.name = _data["Name"];
            this.portion = _data["Portion"];
            this.externalType = _data["ExternalType"];
            this.categoryType = _data["CategoryType"];
        }
    }

    static fromJS(data: any): SectorMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new SectorMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CategoryId"] = this.categoryId;
        data["ExternalId"] = this.externalId;
        data["Name"] = this.name;
        data["Portion"] = this.portion;
        data["ExternalType"] = this.externalType;
        data["CategoryType"] = this.categoryType;
        return data;
    }
}

export interface ISectorMessageModel {
    categoryId?: number | undefined;
    externalId?: string | undefined;
    name?: string | undefined;
    portion?: number;
    externalType?: string | undefined;
    categoryType?: number | undefined;
}

export enum InstrumentState {
    Draft = 0,
    Active = 1,
    Deactivated = 2,
}

export class InsightBaseContract implements IInsightBaseContract {
    companyIdentityId?: number;

    constructor(data?: IInsightBaseContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyIdentityId = _data["CompanyIdentityId"];
        }
    }

    static fromJS(data: any): InsightBaseContract {
        data = typeof data === 'object' ? data : {};
        let result = new InsightBaseContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyIdentityId"] = this.companyIdentityId;
        return data;
    }
}

export interface IInsightBaseContract {
    companyIdentityId?: number;
}

export class QueryLookupInstrumentsRequest extends InsightBaseContract implements IQueryLookupInstrumentsRequest {
    isin?: string | undefined;
    ticker?: string | undefined;
    currencyCode?: string | undefined;
    instrumentCurrencyCode?: string | undefined;
    availableInstrumentId?: string | undefined;
    searchString?: string | undefined;
    filterByInstrumentType?: InstrumentType | undefined;
    orgNr?: string | undefined;

    constructor(data?: IQueryLookupInstrumentsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isin = _data["Isin"];
            this.ticker = _data["Ticker"];
            this.currencyCode = _data["CurrencyCode"];
            this.instrumentCurrencyCode = _data["InstrumentCurrencyCode"];
            this.availableInstrumentId = _data["AvailableInstrumentId"];
            this.searchString = _data["SearchString"];
            this.filterByInstrumentType = _data["FilterByInstrumentType"];
            this.orgNr = _data["OrgNr"];
        }
    }

    static override fromJS(data: any): QueryLookupInstrumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QueryLookupInstrumentsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Isin"] = this.isin;
        data["Ticker"] = this.ticker;
        data["CurrencyCode"] = this.currencyCode;
        data["InstrumentCurrencyCode"] = this.instrumentCurrencyCode;
        data["AvailableInstrumentId"] = this.availableInstrumentId;
        data["SearchString"] = this.searchString;
        data["FilterByInstrumentType"] = this.filterByInstrumentType;
        data["OrgNr"] = this.orgNr;
        super.toJSON(data);
        return data;
    }
}

export interface IQueryLookupInstrumentsRequest extends IInsightBaseContract {
    isin?: string | undefined;
    ticker?: string | undefined;
    currencyCode?: string | undefined;
    instrumentCurrencyCode?: string | undefined;
    availableInstrumentId?: string | undefined;
    searchString?: string | undefined;
    filterByInstrumentType?: InstrumentType | undefined;
    orgNr?: string | undefined;
}

export class LookupExchangeResponseItem implements ILookupExchangeResponseItem {
    lookupAvailableInstrumentId?: string;
    mic?: string | undefined;
    exchangeName?: string | undefined;

    constructor(data?: ILookupExchangeResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lookupAvailableInstrumentId = _data["LookupAvailableInstrumentId"];
            this.mic = _data["Mic"];
            this.exchangeName = _data["ExchangeName"];
        }
    }

    static fromJS(data: any): LookupExchangeResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new LookupExchangeResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LookupAvailableInstrumentId"] = this.lookupAvailableInstrumentId;
        data["Mic"] = this.mic;
        data["ExchangeName"] = this.exchangeName;
        return data;
    }
}

export interface ILookupExchangeResponseItem {
    lookupAvailableInstrumentId?: string;
    mic?: string | undefined;
    exchangeName?: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function getTraceParent(span: Span) {
  return `00-${span.spanContext().traceId}-${span.spanContext().spanId}-0${Number(span.spanContext().traceFlags || TraceFlags.NONE).toString(16)}`;
}